import React from 'react';
import { CateringOrderForm } from '../components/CateringOrderForm';
export function CateringPage() {
  return <div className="min-h-screen py-12 px-4" data-id="element-164">
      <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-165">
        <h1 className="text-4xl md:text-6xl font-retro text-white mb-6" data-id="element-166">
          Catering Services
        </h1>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-167">
          Make your next event unforgettable with authentic BBQ from Short Stop.
          Perfect for office parties, family reunions, and tailgates.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-168">
        {/* Info Column */}
        <div className="lg:col-span-1 space-y-6" data-id="element-169">
          <div className="bg-primary/10 p-6 rounded-xl border border-primary/20" data-id="element-170">
            <h3 className="text-xl font-retro text-primary mb-3" data-id="element-171">
              Why Choose Us?
            </h3>
            <ul className="space-y-3 text-gray-300 text-sm" data-id="element-172">
              <li className="flex items-start" data-id="element-173">
                <span className="mr-2 text-primary" data-id="element-174">•</span>
                Authentic wood-smoked meats
              </li>
              <li className="flex items-start" data-id="element-175">
                <span className="mr-2 text-primary" data-id="element-176">•</span>
                Homemade sides and sauces
              </li>
              <li className="flex items-start" data-id="element-177">
                <span className="mr-2 text-primary" data-id="element-178">•</span>
                Flexible packages for any budget
              </li>
              <li className="flex items-start" data-id="element-179">
                <span className="mr-2 text-primary" data-id="element-180">•</span>
                Reliable, friendly service
              </li>
            </ul>
          </div>

          <div className="bg-dark-card p-6 rounded-xl border border-gray-800" data-id="element-181">
            <h3 className="text-xl font-retro text-white mb-3" data-id="element-182">Need Help?</h3>
            <p className="text-gray-400 text-sm mb-4" data-id="element-183">
              Not sure how much to order? Give us a call and we'll help you plan
              the perfect menu.
            </p>
            <p className="text-xl font-bold text-white" data-id="element-184">812-334-0266</p>
          </div>
        </div>

        {/* Form Column */}
        <div className="lg:col-span-2" data-id="element-185">
          <CateringOrderForm data-id="element-186" />
        </div>
      </div>
    </div>;
}